export const ACTIVE_USER_STATUS_ID = 1
export const PENDING_USER_STATUS_ID = 2

export const ACTIVE_USER_STATUS = 'active'
export const PENDING_USER_STATUS = 'pending'

const userStatuses = [
  {label: ACTIVE_USER_STATUS, value: ACTIVE_USER_STATUS_ID},
  {label: PENDING_USER_STATUS, value: PENDING_USER_STATUS_ID}

]

export default userStatuses
